import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "14",
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"Logo\"><path id=\"Vector\" d=\"M2.45425 11.3749H4.29175V6.92254L1.66675 4.95825V10.5892C1.66675 11.024 2.01981 11.3749 2.45425 11.3749Z\" fill=\"#4285F4\"></path><path id=\"Vector_2\" d=\"M10.7083 11.3749H12.5458C12.9815 11.3749 13.3333 11.0227 13.3333 10.5892V4.95825L10.7083 6.92254\" fill=\"#34A853\"></path><path id=\"Vector_3\" d=\"M10.7083 3.4472V7L13.3333 4.95031V3.85714C13.3333 2.84323 12.2216 2.26521 11.4433 2.87329\" fill=\"#FBBC04\"></path><path id=\"Vector_4\" d=\"M4.29175 6.94697V3.5L7.50008 5.88636L10.7084 3.5V6.94697L7.50008 9.33333\" fill=\"#EA4335\"></path><path id=\"Vector_5\" d=\"M1.66675 3.85714V4.95031L4.29175 7V3.4472L3.55675 2.87329C2.77712 2.26521 1.66675 2.84323 1.66675 3.85714Z\" fill=\"#C5221F\"></path></g>", 1)
  ])))
}
export default { render: render }